var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartControlPanLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "pathStyle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Interactive-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    fill: "#B7B7B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M11.2928932,4.29289322 L6.29289322,9.29289322 C5.90236893,9.68341751 5.90236893,10.3165825 6.29289322,10.7071068 L11.2928932,15.7071068 C11.6834175,16.0976311 12.3165825,16.0976311 12.7071068,15.7071068 C13.0976311,15.3165825 13.0976311,14.6834175 12.7071068,14.2928932 L8.41421356,10 L12.7071068,5.70710678 C13.0976311,5.31658249 13.0976311,4.68341751 12.7071068,4.29289322 C12.3165825,3.90236893 11.6834175,3.90236893 11.2928932,4.29289322 Z",
    id: "Icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartControlPanLeft);
export default __webpack_public_path__ + "static/media/chartControl_PanLeft.e400b350b9824486314713ea024601e5.svg";
export { ForwardRef as ReactComponent };